import { ListCellFallback } from '@cbhq/cds-web/cells';
import { Box, Fallback, HStack, VStack } from '@cbhq/cds-web/layout';

const DETAIL_SKELETON_ROWS = [0, 1] as const;
const DEVICE_NETWORK_SKELETON_ROWS = [0, 1, 2, 3] as const;

type AuditDetailSectionSkeletonProps = {
  rows: readonly number[];
};

function AuditDetailSectionSkeleton({ rows }: AuditDetailSectionSkeletonProps) {
  return (
    <VStack width="100%" gap={0}>
      <Box width="100%" paddingX={3} paddingY={1}>
        <Fallback width={96} height={16} />
      </Box>
      {rows.map((row) => (
        <ListCellFallback
          key={row}
          spacingVariant="condensed"
          title
          detail
          disableRandomRectWidth
          rectWidthVariant={row}
        />
      ))}
    </VStack>
  );
}

export function AuditDetailTraySkeleton() {
  return (
    <>
      <HStack alignItems="center" gap={1.5} paddingX={4} paddingY={1} width="100%">
        <Fallback width={20} height={20} shape="circle" />
        <Fallback width={220} height={24} />
      </HStack>
      <VStack
        width="100%"
        gap={3}
        paddingX={1}
        paddingTop={4}
        flexGrow={1}
        testID="audit-detail-tray-skeleton"
      >
        <VStack width="100%" gap={0}>
          <Box width="100%" paddingX={3} paddingY={0.5}>
            <Fallback width={64} height={16} />
          </Box>
          <Box width="100%" paddingX={1.5}>
            <Box width="100%" height={60} justifyContent="center" paddingX={1.5}>
              <HStack alignItems="center" gap={1} width="100%">
                <Fallback width={32} height={32} shape="circle" />
                <VStack minWidth={0} gap={0.5}>
                  <Fallback width={148} height={18} />
                  <Fallback width={196} height={14} />
                </VStack>
              </HStack>
            </Box>
          </Box>
        </VStack>
        <AuditDetailSectionSkeleton rows={DETAIL_SKELETON_ROWS} />
        <AuditDetailSectionSkeleton rows={DEVICE_NETWORK_SKELETON_ROWS} />
      </VStack>
      <VStack width="100%" paddingX={1} paddingBottom={3}>
        <ListCellFallback
          spacingVariant="condensed"
          title
          detail
          disableRandomRectWidth
          rectWidthVariant={2}
        />
      </VStack>
    </>
  );
}
